module.exports = "<div class=\"leaflet-control control obs-map-context-info\"> <p class=ref-label>{{referenceLabel}}</p> <div class=\"val ref-val\">{{reference.name}} : {{referenceValue}}</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/observatoire/ng/maps/epci/obsEpciMapContextInfo.html
// module id = 888
// module chunks = 2 11 12